import { Card } from "./card.model";

export const CARDS: Card[] = [
  { title: 'NUMBER_OF_UNDEVELOPED_PROPERTIES', field: "undevelopedCount" },
  { title: 'NUMBER_OF_TAXABLE_UNDEVELOPED_PROPERTIES', field: 'taxableUndeveloped' },
  { title: 'NUMBER_OF_DEVELOPED_PROPERTIES', field: 'developedCount' },
  { title: 'NUMBER_OF_TAXABLE_DEVELOPED_PROPERTIES', field: 'taxableDeveloped' },
  { title: 'NUMBER_OF_ABANDONED_PROPERTIES', field: 'abandonedProperties' }
];
